import { compose } from 'recompose';
import { addProps } from 'utils/recompose';
import { connect } from 'react-redux';
import { seriesListIds } from 'reducers/series/selectors';
import { mini } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';

const mapStateToProps = combineSelectors({
  seriesListIds,
  mini,
});

export const selectedModelId = ({
  match: {
    params: { modelId },
  },
}) => modelId;

export const selectedSeriesId = ({
  match: {
    params: { seriesId },
  },
}) => seriesId;

export default compose(
  connect(mapStateToProps),
  addProps({ selectedModelId, selectedSeriesId }),
);
